import React from 'react'
import { X } from 'react-feather'

const RejectionPopup = ({onClose, content = ''}) => {
  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onClose === 'function'){
      onClose(false)
    }
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center lg:items-center overflow-y-auto"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)', animation: 'darkFadeIn 0.1s ease-in-out'}}
      onClick={handleClose}
    >
      <div className="container mx-auto my-10 lg:my-0 pointer-events-none">
        <div className="w-full lg:w-8/12 mx-auto px-4 py-5 lg:px-8 lg:py-8 bg-white rounded pointer-events-none">
          <div className="lg:w-auto mx-auto pointer-events-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-5">
              <h1 className="text-lg lg:text-3xl text-left font-bold font-primary">
                Apa yang harus diperbaiki?
              </h1>
              <X className="cursor-pointer" onClick={handleClose}/>
            </div>

            <hr className="mb-5 lg:mb-10"/>

            <div className="text-left prose" dangerouslySetInnerHTML={{__html: content}}/>
          </div>
        </div>
      </div>
    </div>
  )
}

export { RejectionPopup }

/* Default dummy content

<div className="text-left">
  <p className="text-lg font-bold mb-2">Lorem Panisian</p>
  <div className="text-sm text-gray-444 mb-8">
    <p className="mb-4">
      Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud
    </p>
    <p className="mb-4">
      Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint.
    </p>
  </div>
  <p className="text-lg font-bold mb-2">Ipsum sit dolor</p>
  <div className="text-sm text-gray-444 mb-8">
    <p className="mb-4">
      Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
    </p>
    <p className="mb-4">
      Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint.
    </p>
  </div>
</div>

*/
